/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';

export const PictureStyled = styled(Picture)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${mediumUp ? 0 : rem(32)};
    `;
  }}
`;

export const RowReverseStyled = styled(Row)`
  flex-direction: row-reverse;
`;
